<!--  -->
<template>
  <div>
    <el-page-header class="page-header" @back="goBack" content="继承记录">
    </el-page-header>

    
    <div class="container">
      <div class="navbar">
      <div class="nav-l">
        <el-input clearable style="width: 27.0rem; " v-model="search" prefix-icon="el-icon-search"
          placeholder="请搜索跟进成员姓名" @change="onSearch">
        </el-input>
        <el-button slot="append" type="primary" @click="onSearch()">搜索</el-button>
      </div>
      <div class="nav-r"></div>
    </div>
      <el-table ref="multipleTable"  :data="tableData" tooltip-effect="dark"
        style="margin-top: 2.0rem" border>
        <el-table-column prop="handover_userid_avatar" label="原跟进成员头像"  show-overflow-tooltip>
          <template slot-scope="scope">
            <el-image style="width: 3.0rem; height: 3.0rem" :src="scope.row.handover_userid_avatar"
              :preview-src-list="[scope.row.handover_userid_avatar]" fit="scale-down"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="handover_userid_name" label="原跟进成员" show-overflow-tooltip></el-table-column>
        <el-table-column prop="takeover_userid_avatar" label="接替成员头像"  show-overflow-tooltip>
          <template slot-scope="scope">
            <el-image style="width: 3.0rem; height: 3.0rem" :src="scope.row.takeover_userid_avatar"
              :preview-src-list="[scope.row.takeover_userid_avatar]" fit="scale-down"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="takeover_userid_name" label="接替成员" show-overflow-tooltip></el-table-column>
        <el-table-column fixed="right" label="操作" width="170">
          <template slot-scope="scope">
            <el-button @click="handlePreview(scope.row)" type="primary" size="mini">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" :page-sizes="[10, 20, 50, 100]"
        @pagination="getDimissionRecord" />
    </div>
    <right-people ref="dialog" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Pagination from "@/components/Pagination";
import rightPeople from '@/components/drawer/rightPeople';
export default {
  name: "departureInheritanceList",
  components: {
    Pagination,
    rightPeople
  },
  data() {
    return {
      search: "",
      tableData: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      multipleSelection: [],
      userid: "",
      title: "",
      person: {
        name: "",
        id: "",
      },
      module: "",
      checkbox: false
    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.getDimissionRecord();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onSelectPerson() {
      this.module = "getAddressBook";
      this.$refs.dialog.open();
    },
    handleSelect(person) {
      this.person = person;
    },
    getDimissionRecord() {
      this.axios
        .post(
          "/crm/dimission/getDimissionRecord",
          qs.stringify({
            phone: this.tooken.phone,
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            name: this.search,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
            status: 1,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          const data = res.data;
          if (data.code == 1) {
            this.tableData = data.data;
            this.total = data.count;
          }
        })
        .catch(function (err) { });
    },
    onSelection(val) {
      this.multipleSelection = val;
    },
    onSearch() {
      this.tableData = [];
      this.getDimissionRecord();
    },
    handlePreview(row) {
      this.$router.push({
        name: "departureInheritanceState2",
        query: {
          handover_userid: row.handover_userid,
          takeover_userid: row.takeover_userid,
        },
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
  },
};
</script>
<style scoped>
.container{
  background-color: #fff;
  border-radius: .8rem;
  padding: 3.0rem;
}
.el-page-header{
  margin-top: -.4rem;
}
</style>